import {ChangeDetectorRef, Component, forwardRef, Optional} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {FUIFormContext} from "../../form-context/form-context";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FUIDateControlComponent),
    multi: true
};

@Component({
    selector: "fui-date-control",
    styleUrls: ["./date-control.component.scss"],
    providers: [CUSTOM_VALUE_ACCESSOR],
    templateUrl: "./date-control.component.html",
    standalone: false
})
export class FUIDateControlComponent extends FUIAbstractControl {
    constructor(changeDetectorRef: ChangeDetectorRef,
                @Optional() public context: FUIFormContext) {
        super(changeDetectorRef);
    }
}
